module.exports = __webpack_public_path__ + "img/individual_weddingrings_spread@2x.3d84e60.jpg";